import { createApp } from 'vue'
import ElDialog from 'element-plus'
import ElIcons from '../../components/ElIcons'
import ElButtons from '../../components/ElButtons'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'dayjs/locale/zh-cn';
import 'element-plus/dist/index.css'
import store from '../../store'

function makeDialog(option) {
  var dom = document.createElement('div');
  document.getElementsByTagName('body')[0].appendChild(dom);

  //动态创建template
  let tpl = '\
        <el-dialog \
            :width="dialogWidth"\
            :top="dialogTop"\
            :close-on-click-modal="true" \
            :destroy-on-close="true" \
            :custom-class="customClass" \
            :title="title" \
            v-model="show" \
            :before-close="handleClose" \
            @close="close">\
                <dialogContent  @close="closeDialog" @confirm="confirmDialog" @goNext="goNext" :value="dialogData"></dialogContent>\
        </el-dialog>';

  //创建一个Vue实例
  const app = createApp({
    data () {
      return {
        //从调用文件获取(参数传入)
        title: option.title,
        show: true,
        dialogData: option.data,
        dialogWidth: '675px',
        dialogTop: '10vh'
      };
    },
    template: tpl,
    computed: {
      customClass(){
        return `el-dialog--width-${option.size || 'auto'}`;
      }
    },
    methods: {
      handleClose(done){
        const a = document.getElementsByClassName('el-image-viewer__wrapper')[0];
        if(!a) {
          if (option.beforeClose) {
            option.beforeClose(done);
          } else {
            done();
          }
        }
      },
      close() {
        if (option.close) {
          option.close();
        }
        document.getElementsByTagName('body')[0].removeChild(dom);
      },

      closeDialog(){
        this.show = false
      },
      confirmDialog(result){
        this.show = false
        option.confirm && option.confirm(result)
      },
      goNext(result){
        this.show = false
        option.goNext && option.goNext(result)
      }
    },
    components: {
      dialogContent: option.component,//传入的内容模块
    },
    created() {
      if(option.data.width){
        this.dialogWidth = option.data.width;
      }
    }
  })
  app.directive('high-light', {
    beforeMount: function (el, binding) {
      let value = binding.value;
      let changeValue = value.value;
      let array = changeValue.split('');
      let allStr = '';
      for(let i=0;i<array.length;i++) {
        let str = array[i] + array[i+1] + array[i+2] + array[i+3] + array[i+4];
        if(str == '充值备注：' || str == '预约备注：' || str == '回访备注：') {
          allStr += "<font style='font-weight: bold'>" + str + "</font>";
          i += 4;
        }else{
          allStr += array[i];
        }
      }
      el.innerHTML = allStr;
    },
    updated: function (el, binding) {
      let value = binding.value;
      let changeValue = value.value;
      let array = changeValue.split('');
      let allStr = '';
      for(let i=0;i<array.length;i++) {
        let str = array[i] + array[i+1] + array[i+2] + array[i+3] + array[i+4];
        if(str == '充值备注：' || str == '预约备注：' || str == '回访备注：') {
          allStr += "<font style='font-weight: bold'>" + str + "</font>";
          i += 4;
        }else{
          allStr += array[i];
        }
      }
      el.innerHTML = allStr;
    }
  })
  app.component('ElIcons', ElIcons)
  app.component('ElButtons', ElButtons)
  app.use(ElementPlus, { size: 'default', zIndex: 3000, locale: zhCn })
  app.use(ElDialog, { size: 'default', zIndex: 888 }).mount(dom);
  app.use(store)
  return app;
}

export default {
  open(options){
    return makeDialog(options)
  }
}
